import { useState } from "react";
import { ArrowRight } from "lucide-react";
import { SOLUCOES } from "../../lib/site";

const ACCENT = {
  cyan: "bg-cyan-400",
  magenta: "bg-fuchsia-400",
  yellow: "bg-amber-400",
  purple: "bg-violet-400",
};

export const SolucoesCatalog = () => {
  const keys = Object.keys(SOLUCOES);
  const [active, setActive] = useState(keys[0]);
  const current = SOLUCOES[active];

  return (
    <section
      id="solucoes"
      data-testid="solucoes-section"
      className="relative py-24 md:py-32"
    >
      <div className="nx-blob bg-[#4c2e9b]/60 w-[500px] h-[500px] top-0 right-0" aria-hidden />
      <div className="max-w-7xl mx-auto px-6 md:px-8">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-10 md:mb-14">
          <div className="max-w-2xl">
            <span className="overline">Catálogo de soluções</span>
            <h2 className="font-display mt-4 text-3xl md:text-5xl font-medium tracking-tight text-white leading-[1.08]">
              Um portfólio completo em{" "}
              <span className="text-white/60 italic font-light">quatro frentes</span>.
            </h2>
          </div>
          <p className="text-[15px] text-[#b3b0c2] max-w-md">
            Navegue pelas categorias e descubra como o Grupo Nexus pode estruturar e proteger sua
            operação.
          </p>
        </div>

        {/* Tabs */}
        <div className="relative flex overflow-x-auto scrollbar-none -mx-6 md:mx-0 px-6 md:px-0 gap-2 md:gap-3 border-b border-white/10">
          {keys.map((k) => {
            const item = SOLUCOES[k];
            const isActive = k === active;
            return (
              <button
                key={k}
                onClick={() => setActive(k)}
                data-testid={`solucoes-tab-${k}`}
                data-active={isActive}
                className={`relative shrink-0 px-4 md:px-6 py-4 text-[13px] md:text-[14px] font-medium transition-colors ${
                  isActive ? "text-white" : "text-white/55 hover:text-white/85"
                }`}
              >
                <span className="flex items-center gap-2.5">
                  <span className={`h-1.5 w-1.5 rounded-full ${ACCENT[item.accent]}`} />
                  {item.label}
                </span>
                {isActive && (
                  <span className="absolute left-4 right-4 md:left-6 md:right-6 -bottom-px h-[2px] bg-gradient-to-r from-cyan-400 via-amber-300 to-fuchsia-400" />
                )}
              </button>
            );
          })}
        </div>

        {/* Grid */}
        <div className="mt-10 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
          {current.items.map((it, i) => (
            <article
              key={it.title}
              data-testid={`solucao-card-${active}-${i}`}
              className="group relative rounded-2xl border border-white/10 bg-[#0A0810] p-6 transition-all duration-300 hover:-translate-y-1 hover:border-white/25 hover:shadow-[0_8px_32px_rgba(76,46,155,0.25)]"
            >
              <div className="flex items-center justify-between">
                <span className="font-display text-xs text-white/40">
                  {String(i + 1).padStart(2, "0")}
                </span>
                <ArrowRight
                  size={16}
                  className="text-white/40 group-hover:text-white group-hover:translate-x-0.5 transition-all"
                />
              </div>
              <h3 className="font-display mt-8 text-[19px] text-white font-medium leading-snug">
                {it.title}
              </h3>
              <p className="mt-3 text-[13.5px] text-[#a19eb0] leading-relaxed">{it.desc}</p>
              <div className={`mt-6 h-[2px] w-8 ${ACCENT[current.accent]} opacity-70`} />
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default SolucoesCatalog;
